import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import DispalyImage from 'components/wrapperComponents/DispalyImage';
import { msgTypes } from 'constants/msgTypes';
import { AnnouncementModel } from 'model/screensModels/AnnouncementModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { AnnouncementService } from 'services/menu/announcementService/AnnouncementService';
import { NewsLettersService } from 'services/menu/newsLettersService/NewsLettersService';
import ApiUrl from 'services/shared/ApiUrl';
import CreateNewsAnnouncements from './CreateNewsAnnouncements';
import { NewsAnnouncementList } from './NewsAnnouncementList';

export const NewsAnnouncements = () => {

  const [updateValue, setUpdateValue] = React.useState(new AnnouncementModel());
  const [flag, setFlag] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [recentAnnouncements, setRecentAnnouncements] = useState(new AnnouncementModel());
  const [newsAnnouncements, setNewsAnnouncements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const TRUNCATE_LENGTH = 70;
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 500,
    dots: false,
    ArrowBack: false,
    slidesToShow: 4,
    variableWidth: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: newsAnnouncements?.length > 5 ? 5 : newsAnnouncements?.length,
          slidesToScroll: 1,
          infinite: newsAnnouncements?.length > 5,
        },
      },
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: newsAnnouncements?.length > 4 ? 4 : newsAnnouncements?.length,
          slidesToScroll: 1,
          infinite: newsAnnouncements?.length > 4,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: newsAnnouncements?.length > 3 ? 3 : newsAnnouncements?.length,
          slidesToScroll: 1,
          infinite: newsAnnouncements?.length > 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: newsAnnouncements?.length > 3 ? 3 : newsAnnouncements?.length,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: newsAnnouncements?.length > 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: newsAnnouncements?.length > 2 ? 2 : newsAnnouncements?.length,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: newsAnnouncements?.length > 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: newsAnnouncements?.length > 1 ? 1 : newsAnnouncements?.length,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: newsAnnouncements?.length > 1,
        },
      },
    ],
  };


  React.useEffect(() => {
    loadRecentAnnouncement();
  }, [])

  const getUpdateRecordValue = (announcementModel: AnnouncementModel) => {
    setIsEditMode(true);
    setUpdateValue(announcementModel);
  }

  const addAnnouncement = () => {
    setUpdateValue(new AnnouncementModel());
    setIsEditMode(false); // Reset edit mode
    setFlag(true)
  }

  //Prepare request body to get recent announcement
  const prepareRequest = async () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;

    //get Company Id
    const userDetails = await LocalStorageService.getUserDetails();
    if (userDetails !== '') {
      const companyDetails = JSON.parse(userDetails)
      requestBody.companyId = companyDetails.companyId;
    }
    return requestBody;
  }

  //Get Announcements list
  const loadRecentAnnouncement = async () => {
    const requestBody = await prepareRequest();
    const res = await AnnouncementService.getAnnouncementList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res?.data !== '') {
        setRecentAnnouncements(res?.data?.tbody[0]);
      } else {
        setRecentAnnouncements(new AnnouncementModel())
      }
    }
  }

  const RecentAnnouncements = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently added Announcement </h5>
        {recentAnnouncements.announcementId !== '' ? (
          <div>
            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Title : </h5>
              </div>
              <div className='col-lg-8'>
                {recentAnnouncements.title}
              </div>
            </div>

            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Description : </h5>
              </div>
              <div className='col-lg-8'>
                {recentAnnouncements.message}
              </div>
            </div>

            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Attachments : </h5>
              </div>
              <div className='col-lg-8'>
                <img src={ApiUrl.fileBaseUrl + recentAnnouncements.attachment} className="recentdded-section"></img>
              </div>
            </div>
          </div>
        ) : (
          <>
            <DataNotFound message="There is no Announcement" />
          </>
        )}
      </>
    )
  }


  useEffect(() => {
    recentlyAddedNewsletters();
  }, []);

  const handleOpenDialog = (service) => {
    setSelectedService(service);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedService(null);
  };

  const recentlyAddedNewsletters = async () => {
    const res = await NewsLettersService.recentlyAddedNewsletters();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      // Extract All The Data Of Newsletter
      if (res.data !== '') {
        const newsAnnouncements = res.data.tbody.map((data) => ({
          image: data.image,
          title: data.title,
          description: data.description,
          link: data.link
        }));
        setNewsAnnouncements(newsAnnouncements);
      }
    }
  };

  return (

    <Box sx={{ width: '100%' }} className="container container-h-full">
      <Box>
     
        <div className="content-subheader">
            {!flag ? (
              <h2 className="font-weight-bolder">Announcement List</h2>
            ) : (
              <h2 className="font-weight-bolder">{isEditMode ? 'Edit Announcement' : ' Create Announcement'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addAnnouncement}>Add Announcement</button>}
          </div>
      </Box>

      {flag ?
        (
          <>
            {/* Begin::News Submission Message */}
            <div className="card outer-box-text border-0 card--">
              <div className="outer-box-text-one"></div>
              <div className="card-header pb-0">
                <div className="content-subheader">
                  <h4 className="submission mr-3"> News Submission</h4>
                </div>
              </div>
              <div className="card-body">
                <div className=" mt-0 mx-0">
                  <p>
                    We’d love to hear from you! If you have any exciting shipments or cargo movements that you’ve been part of, please share your stories and photos with us for our 1WN Quarterly Newsletter and Network News.<br></br>
                    Just fill out the form below with as many details as you can. After you submit, our team will review everything, and we’ll send you a draft article for your approval. We want to make sure we capture all the important details and that you’re happy with how it looks! Thank you for contributing to our community!
                  </p>
                </div>
              </div>
            </div>
            {/* End::News Submission Message */}

            {/* Begin::Display Admin newsletters */}
            {newsAnnouncements.length > 0 && (
              <div className="card newsletter border-0 mb-3">
                <div className="card-body p-0">
                  <Grid container className="main-grid-1">
                    <Box className="heading-1-main-box">
                      <h6 className=" status-sec">Recently Added Newsletter</h6>
                      <Box>
                        <Grid item>
                          <Grid item className="content-p">
                            <Typography className="heading-1-text">
                              <div className="full-width-carousel">
                                <Slider {...settings}>


                                  {newsAnnouncements.map((data, index) => (
                                    <div className='announcement-sec' key={index}>
                                      <Card className="my-3 news-added mr-3">
                                   
                                        <DispalyImage
                                          imageUrl={data.image}
                                          imageSize={msgTypes.IMAGE_SIZE.MEDIUM} />
                                        <CardContent className="news-content-pre" style={{ height: "80px" }}>
                                          <p>
                                            {data.title}
                                          </p>
                                        
                                          {data.description.length > TRUNCATE_LENGTH && (
                                            <Button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenDialog(data);
                                              }}
                                              style={{
                                                marginLeft: "10px",
                                                textTransform: "none",
                                              }}
                                              className="btn view-detail ml-0 mt-2"
                                            >
                                              View Details
                                            </Button>
                                          )}
                                        </CardContent>
                                        {/* </CardActionArea> */}
                                      </Card>
                                      {/* </a> */}

                                    </div>
                                  ))}
                                </Slider>
                              </div>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </div>
              </div>
            )}
            {/* End::Display Admin newsletters */}

            {/* Begin:: Create invoice */}
            <div className='row card--'>
              <div className='col-lg-4 work '>
                <div className='sub-content-sec recently-blog'>
                  <RecentAnnouncements />
                </div>
              </div>
              <div className='col-lg-8'>
                {/* <div className='sub-content-sec'> */}
                <CreateNewsAnnouncements setFlag={setFlag} updateRecord={updateValue} loadRecentAnnouncement={loadRecentAnnouncement} />
                {/* </div> */}
              </div>
            </div>
            {/* End:: Create Invoice */}
          </>
        )
        : (
          <div className='sub-content-sec recently-blog'>
            <NewsAnnouncementList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentAnnouncement={loadRecentAnnouncement}></NewsAnnouncementList>
          </div>
        )
      }
      {/* Begin:: Dialog Box */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className="d-flex justify-content-center">
          {selectedService?.title}
          <div className="close-modal" onClick={handleCloseDialog}>
            <CloseIcon />
          </div>
        </DialogTitle>
        <DialogContent>
          {selectedService?.image && (
            <img
              src={ApiUrl.fileBaseUrl + selectedService.image}
              alt={selectedService?.title}
              style={{ width: "100%", height: "auto", marginBottom: "10px" }}
            />
          )}
          <Typography>{selectedService?.description}</Typography>
        </DialogContent>
      </Dialog>
      {/* End:: Dialog Box */}

    </Box>



  )
}
